import { TokenService } from '../../oauth/token.service'
import { gql } from '@apollo/client'
import { client } from '../../../graphql'


export const GET_CUSTOMERS_QUERY = gql`
   query GetAllCustomers {
     customers(pageSize: -1) {
       customers {
         id
         name
       }
     }
   }
 `

export const fetchCustomerList = async (): Promise<any> => {
  try {
    const { data } = await client.query({
      query: GET_CUSTOMERS_QUERY,
    })

    return data
  } catch (error: any) {
    if (error?.response?.status === 401) {
      TokenService.refreshToken('UNAUTHENTICATED')
    }
    throw error
  }
}
